import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { LoginPage } from './auth/LoginPage';
import { Layout, RequireRole } from './components/Layout';
import { Button, Loading } from './components/ui';
import { CorrectionsPage } from './pages/corrections/CorrectionsPage';
import { EmployeeDetailPage } from './pages/employees/EmployeeDetailPage';
import { EmployeesPage } from './pages/employees/EmployeesPage';
import { ExceptionsPage } from './pages/exceptions/ExceptionsPage';
import { ExportPage } from './pages/export/ExportPage';
import { LivePage } from './pages/live/LivePage';
import { MessagesPage } from './pages/messages/MessagesPage';
import { PeriodDetailPage } from './pages/periods/PeriodDetailPage';
import { PeriodsPage } from './pages/periods/PeriodsPage';
import { TimesheetPage } from './pages/periods/TimesheetPage';
import { ReportsPage } from './pages/reports/ReportsPage';
import { RostersPage } from './pages/rosters/RostersPage';
import { RulesPage } from './pages/rules/RulesPage';
import { SettingsRoutes } from './pages/settings/SettingsRoutes';

export function App() {
  const { status, session, refresh, signOut } = useAuth();
  if (status === 'loading') return <Loading label="Signing in" />;
  if (status === 'unreachable')
    return (
      <div className="auth-screen">
        <div className="card auth-card">
          <div className="card-body stack">
            <h1>Cannot reach the server</h1>
            <p className="muted">Your sign-in is kept. The server may be restarting; try again in a moment.</p>
            <div className="row">
              <Button variant="primary" onClick={() => void refresh()}>
                Try again
              </Button>
              <Button variant="ghost" onClick={() => void signOut()}>
                Sign out
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  if (status !== 'signed_in' || !session || session.mfaSetupRequired || session.mustChangePassword) return <LoginPage />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<ExceptionsPage />} />
        <Route path="live" element={<LivePage />} />
        <Route path="messages" element={<MessagesPage />} />
        <Route path="periods" element={<PeriodsPage />} />
        <Route path="periods/:id" element={<PeriodDetailPage />} />
        <Route
          path="periods/:id/export"
          element={
            <RequireRole min="payroll_admin">
              <ExportPage />
            </RequireRole>
          }
        />
        <Route path="timesheets/:id" element={<TimesheetPage />} />
        <Route path="corrections" element={<CorrectionsPage />} />
        <Route path="rosters" element={<RostersPage />} />
        <Route path="employees" element={<EmployeesPage />} />
        <Route path="employees/:id" element={<EmployeeDetailPage />} />
        <Route
          path="rules"
          element={
            <RequireRole min="payroll_admin">
              <RulesPage />
            </RequireRole>
          }
        />
        <Route path="reports" element={<ReportsPage />} />
        <Route
          path="settings/*"
          element={
            <RequireRole min="payroll_admin">
              <SettingsRoutes />
            </RequireRole>
          }
        />
        <Route path="login" element={<Navigate to="/" replace />} />
        <Route
          path="*"
          element={
            <div className="card">
              <div className="empty">
                <strong>Page not found</strong>
                <a href="/">Go to the exceptions queue</a>
              </div>
            </div>
          }
        />
      </Route>
    </Routes>
  );
}
